const URLS = {
    home: '/',
    session: {
        auth: '/api/auth',
        login: '/login',
        logout: '/logout',
        isAuth: '/isAuth',
        resetPassword: '/resetPassword',
        magicLogin: '/magicLogin',
        magicAuth: '/auth/magic',
        updateCurrentUser: '/api/me',
        updatePassword: '/api/password',
        setPassword: '/setPassword',
        forgotPassword: '/api/password/forgot',
        newPassword: '/newPassword/:token'
    },
    app: {
        data: '/api/app/data'
    },
    client: {
        index: '/clients',
        show: '/clients/:id',
        new: '/api/clients',
        get: '/api/clients',
        update: '/api/clients/:id',
        newHive: '/api/clients/:id/hives',
        updateHive: '/api/clients/:id/hives/:hive'
    },
    hives: {
        index: '/hives'
    },
    reports: {
        new: '/api/reports',
        get: '/api/reports/:id',
        export: '/api/reports/exports'
    },
    users: {
        index: '/users',
        get: '/api/users',
        put: '/api/users/:id',
        show: '/users/:id',
        new: '/users/new'
    }
}

export default URLS


// WEBPACK FOOTER //
// ./src/constant/URLS.js